import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AddWIEvents from "../../../views/popups/users/AddWIEvents";
import PopupLoader from "../../../views/popups/PopupLoader";
import {
  MDBBtn,
  MDBDatatable,
  MDBIcon,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import { useFieldArray, useForm } from "react-hook-form";
import DeleteWIEventType from "../../../views/popups/users/DeleteWIEventType";
import { getStreamsProductName } from "../../../apiclients/CommonUtils";

function WebInt({
  updateWebIntEventActive,
  useragent,
  webIntegration,
  setwebIntegration,
  register,
  parentWatch,
  setRerender,
  setSuccessMessage,
  parentreset,
  parentErrors,
  parentClearErrors,
  parentSetValue
}) {
  const { t, i18n } = useTranslation();
  const [addWebIEvent, setAddWebIEvent] = useState(false);
  const togglePopup = () => setAddWebIEvent(!addWebIEvent);
  const toggleDeleteWiEvents = () => setDeleteWi(!deletewi);
  const [deletewi, setDeleteWi] = useState(false);
  const [deleteWIObj, setdeleteWIObj] = useState({});
  const [eventDetails, seteventDetails] = useState({});
  const [newEventObj, setnewEventObj] = useState({});
  const [isAdd, setisAdd] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const streamsProductName = getStreamsProductName();
  const {
    handleSubmit,
    formState: { errors, isDirty, dirtyFields },
    reset,
    clearErrors,
    setError,
    control,
    watch,
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      webIntegration: [],
    },
  });
  const { fields } = useFieldArray({
    control,
    name: "webIntegration",
  });

  useEffect(() => {
    if (
      webIntegration?.webIntegration &&
      webIntegration?.webIntegration.length > 0
    ) {
      reset({ webIntegration: webIntegration.webIntegration });
    } else {
      reset({ webIntegration: [] });
    }
  }, [webIntegration]);

  async function onSubmit(data) {
    console.log("Dirty Fields ::::::::: " + JSON.stringify(dirtyFields));
    console.log("Dirty Fields ::::::::: " + JSON.stringify(data));
    const dirtyFieldList = dirtyFields.webIntegration;
    const dataList = data.webIntegration;
    let modifiedField = [];
    dirtyFieldList.forEach((field, index) => {
      if (field && field.is_active !== undefined) {
        modifiedField.push({
          event_id: dataList[index].eventids,
          is_enabled: dataList[index].is_active,
        });
      }
    });
    updateWebIntEventActive(modifiedField);
  }

  function deleteSelectedUser(e, selectedObj) {
    setdeleteWIObj(selectedObj);
    toggleDeleteWiEvents();
  }

  function handleRowClick(eventDetailsObj) {
    seteventDetails(eventDetailsObj);
    togglePopup();
  }

  useEffect(() => {
    if ((isAdd || isEdit) && Object.keys(newEventObj).length > 0) {
        let updateFields = [];
        console.log("New Event Object: " + JSON.stringify(newEventObj));
        
        if (isAdd) {
            updateFields = webIntegration.webIntegration?.filter(eachEvent => eachEvent.event_id !== newEventObj.event_id);
            
            if (updateFields.length === 0) {
                const enableWeb = {
                    web_is_enabled: true,
                };
                parentreset({ webintegration: enableWeb });
            }
            
            updateFields = [...updateFields, newEventObj];
            setisAdd(false);
        } else {
            const uniqueKey = newEventObj.event_unique_id;
            updateFields = webIntegration.webIntegration;
            
            const index = updateFields.findIndex(
                (item) => parseInt(item.event_unique_id) === parseInt(uniqueKey)
            );
            
            if (index !== -1) {
                updateFields.splice(index, 1, newEventObj);
            }
            
            setisEdit(false);
        }
        setwebIntegration({webIntegration: updateFields});
        // reset({ webIntegration: updateFields });
        setRerender(true);
    }
}, [isAdd, isEdit]);


  return (
    <>
      <div className="general-settings" id="WebInt">
        {t("WebInt")}
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("EnWebInt")}</div>
        <div className="phoneselect">
          <label className="switch">
            <input
            name = "web_integration.web_is_enabled"
              className="form-control"
              type="checkbox"
              {...register("web_integration.web_is_enabled")}
              onChange={(e) => {
                parentSetValue("web_integration.web_is_enabled", e.target.checked, { shouldDirty: true });
                parentClearErrors("web_integration.web_is_enabled");
              }}
              // onClick={toggleWiEvents}
            />
            <span className="slider round"></span>
          </label>
          {parentErrors?.web_integration?.web_is_enabled?.message && (
            <p className="text-danger">{parentErrors.web_integration.web_is_enabled.message}</p>
          )}
        </div>
      </div>
      {parentWatch("web_integration.web_is_enabled") && (
        <>
          <div className="add-numbermain">
            <div>
              <div className="tel-numbers">{t("WebInt")}</div>
              <span className="phrecording">{t("WebInttxt", {"PRODUCT_NAME" : streamsProductName})}</span>
            </div>
            <div className="d-flex">
              <MDBBtn
                className="m-2"
                onClick={(e) => {
                  seteventDetails({});

                  togglePopup();
                }}
              >
                <MDBIcon fas icon="plus" size="sm" /> {t("AddWebInt")}
              </MDBBtn>
            </div>
          </div>
          <MDBTable className="mt-2">
            <MDBTableHead>
              <tr>
                <th scope="col">{t("EventType")}</th>
                <th scope="col">{t("URL")}</th>
                <th scope="col">{t("BrowserBehaviour")}</th>
                <th scope="col">{t("Active")}</th>
                <th scope="col">{t("Remove")}</th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {fields.map((field, index) => (
                <tr
                  key={field.id}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRowClick(field);
                  }}
                >
                  <td scope="row">{field.event_type}</td>
                  <td className="w-60">
                    <div className="textOverflowShow"> 
                    {field.url}
                    </div>
                    </td>
                  <td>{field.browser_type}</td>
                  <td>
                    <div>
                      <label className="switch" onClick={(e)=> e.stopPropagation()}>
                        <input
                          className="form-control"
                          type="checkbox"
                          checked={watch(`webIntegration.${index}.is_active`)}
                          onChange={(e) => {
                            setValue(
                              `webIntegration.${index}.is_active`,
                              e.target.checked,
                              { shouldDirty: true }
                            );
                            setValue(
                              `webIntegration.${index}.eventids`,
                              parseInt(field.event_id),
                              { shouldDirty: true }
                            );
                            handleSubmit(onSubmit)();
                          }}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </td>
                  <td>
                    <>
                      <MDBIcon
                        className="ms-3"
                        onClick={(e) => {e.stopPropagation();e.preventDefault();deleteSelectedUser(e, field)}}
                        icon="close text-primary"
                      />
                    </>
                  </td>
                </tr>
              ))}
            </MDBTableBody>
          </MDBTable>
          {/* <MDBDatatable className="text-left"
                        search
                        data={{

                            columns: columns,
                            rows: selUserAndPhnum.map((item) => ({ ...item })),
                        }}
                        // fixedHeader
                        // entries={50}
                    ></MDBDatatable> */}
        </>
      )}
      {/* <div className="routing-border mt-2"></div> */}
      {addWebIEvent && (
        <PopupLoader
          title={
            Object.keys(eventDetails).length > 0
              ? "Edit Web Integration"
              : "Add Web Integration"
          }
          content={
            <AddWIEvents
              eventDetails={eventDetails}
              useragent={useragent}
              setSuccessMessage={setSuccessMessage}
              setnewEventObj={setnewEventObj}
              setisAdd={setisAdd}
              setisEdit={setisEdit}
              onClose={togglePopup}
              recordList = {webIntegration?.webIntegration ?? []}
              submitFlag = {true}
            />
          }
          onShow={setAddWebIEvent}
          onClose={togglePopup}
        />
      )}
      {deletewi && (
        <PopupLoader
          title={"Delete User Event"}
          content={
            <DeleteWIEventType
              deleteWIObj={deleteWIObj}
              useragent={useragent}
              setRerender={setRerender}
              setSuccessMessage={setSuccessMessage}
              onClose={toggleDeleteWiEvents}
            />
          }
          onShow={setDeleteWi}
          onClose={toggleDeleteWiEvents}
        />
      )}
    </>
  );
}

export default WebInt;
